<template>
  <transition name="bulk-bar-fade">
    <div v-if="count > 0" class="bulk-actions-bar">
      <div class="bulk-actions-info">
        <strong>{{ count }}</strong>
        {{ count === 1 ? "item selecionado" : "itens selecionados" }}
      </div>
      <div class="bulk-actions-buttons">
        <button
          v-for="(action, i) in actions"
          :key="i"
          type="button"
          :class="['btn', 'btn-sm', `btn-${action.variant || 'primary'}`]"
          @click="$emit('action', action)"
        >
          <i v-if="action.icon" :class="['bx', action.icon, 'me-1']"></i>
          {{ action.label }}
        </button>
        <button
          type="button"
          class="btn btn-sm btn-outline-secondary"
          @click="$emit('clear')"
        >
          Limpar seleção
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "BulkActionsBar",
  props: {
    count: { type: Number, default: 0 },
    actions: { type: Array, default: () => [] },
  },
  emits: ["action", "clear"],
};
</script>

<style scoped>
.bulk-actions-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  background-color: #eaf6ee;
  border: 1px solid #c3e6cb;
  border-radius: 6px;
  padding: 8px 12px;
  margin-bottom: 10px;
}
.bulk-actions-info {
  color: #155724;
  font-size: 0.9rem;
}
.bulk-actions-buttons {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.bulk-bar-fade-enter-active,
.bulk-bar-fade-leave-active {
  transition: opacity 0.15s ease;
}
.bulk-bar-fade-enter-from,
.bulk-bar-fade-leave-to {
  opacity: 0;
}
</style>
